// Display names for AI models. Keys match MODELS in deployment/api/providers.mjs.
export const MODEL_LABELS = {
  claude: "Claude Sonnet 5.5",
  gpt: "GPT-6.1 Sol",
  "or-gemini-flash": "Gemini 3.8 Flash (OpenRouter)",
  "or-deepseek-pro": "DeepSeek V4 Pro (OpenRouter)",
  "or-mistral-large": "Mistral Large 4 (OpenRouter)",
  "or-grok": "Grok 4.7 (OpenRouter)",
  "or-llama-maverick": "Llama 4 Maverick (OpenRouter)",
};
export const modelLabel = key => MODEL_LABELS[key] || MODEL_LABELS.claude;
